import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Container, Row, Col } from 'react-bootstrap';
import './Gallery.css';
import GalleryImage from '../GalleryImage/GalleryImage';




const Gallery = () => {
    const [gallery, setGallery] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetch('https://gentle-tor-99938.herokuapp.com/gallery')
            .then(res => res.json())
            .then((data) => setGallery(data))
            .finally(() => setIsLoading(false));
    }, [])

    return (
        <div>
            {
                isLoading
                    ?
                    <div className="spinner d-flex align-items-center justify-content-center">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                    </div>
                    :
                    <div>
                        <Header></Header>
                        <Container className="my-5 gallery">
                            <Row xs={1} md={3} lg={4} className="g-4 pb-5">
                                {
                                    gallery.map(image => <GalleryImage
                                        key={image.galleryID}
                                        image={image}
                                    />)
                                }
                            </Row>
                        </Container>
                        <Footer></Footer>
                    </div>
            }
        </div>
    );
};

export default Gallery;